module.exports = __webpack_public_path__ + "img/05_kudo_01.04f99373.jpg";